// @ts-ignore
const useStore = () => {
    //return getCurrentInstance()?.proxy.$store
    // @ts-ignore
    return window.marque.ui.app.$store;
};
export { useStore };
